import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  OnInit,
} from '@angular/core';
import icons from './icons.json';

import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ui-keenicon',
  imports: [NgbTooltip],
  templateUrl: './keenicon.component.html',
  styleUrl: './keenicon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeeniconComponent implements OnInit {
  name = input<string>('');
  class = input<string>('');
  type = input<string>('duotone');
  tooltip = input<string>('');

  pathsNumber = 0;

  ngOnInit() {
    if (this.type() === 'duotone') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.pathsNumber = icons[this.type() + '-paths'][this.name()] ?? 0;
    }
  }

  @HostBinding('style.display')
  get styleDisplay() {
    return 'contents';
  }
}
